import SkillsDefaultIcon from '@/pages/aigc/assets/svg/skills-default-icon.svg';
import AgentModeAuthorDefaultIcon from '../../svg/agent-mode-author-default-icon.svg';
import OfficialSkillAvatar from '@/pages/aigc/assets/svg/databrain-logo.svg';
import SkillDetailHeaderBg from '@/pages/aigc/assets/svg/skill-detail-header-bg.svg';
import UsageTabDefaultIcon from '@/pages/aigc/assets/svg/skill-detail-tab-usage-default.svg';
import UsageTabActiveIcon from '@/pages/aigc/assets/svg/skill-detail-tab-usage-active.svg';
import LinkageTabDefaultIcon from '@/pages/aigc/assets/svg/skill-detail-tab-linkage-default.svg';
import LinkageTabActiveIcon from '@/pages/aigc/assets/svg/skill-detail-tab-linkage-active.svg';
import VersionTabDefaultIcon from '@/pages/aigc/assets/svg/skill-detail-tab-version-default.svg';
import VersionTabActiveIcon from '@/pages/aigc/assets/svg/skill-detail-tab-version-active.svg';
import OverviewSectionIcon from '@/pages/aigc/assets/svg/skill-detail-section-overview.svg';
import TokenSectionIcon from '@/pages/aigc/assets/svg/skill-detail-section-token.svg';
import SkillMdFileIcon from '@/pages/aigc/assets/svg/skill-detail-skill-md-file.svg';
import LinkageRobotIcon from '@/pages/aigc/assets/svg/skill-detail-recommend-robot.svg';
import KnotIcon from '@/pages/aigc/assets/svg/knot.svg';
import SkillDetailBackIcon from '@/pages/aigc/assets/svg/skill-detail-back.svg';
import { ESkillDetailTab } from '../types/skillDetail';

/** Skills 列表缓存 Key（与 useSkillsData 保持一致） */
export const SKILLS_LIST_CACHE_KEY = 'SkillsList';

/** 联动案例列表缓存 Key 前缀 */
export const SKILL_LINKAGES_CACHE_KEY_PREFIX = 'SkillLinkages_';

/** 联动案例会话（session_id 类型）数据缓存 Key 前缀 */
export const SKILL_LINKAGE_SESSION_CACHE_KEY_PREFIX = 'SkillLinkageSession_';

/**
 * Skill 详情页请求缓存新鲜度（30 分钟）
 * 会话回放按语种分 key，在 staleTime 内切中英文不重新发请求
 */
export const SKILL_DETAIL_CACHE_STALE_TIME = 1800000;

/** 版本历史列表缓存 Key 前缀 */
export const SKILL_VERSIONS_CACHE_KEY_PREFIX = 'SkillVersions_';

/**
 * Skill 详情页图标配置
 */
export const SKILL_DETAIL_ICONS = {
  defaultSkill: SkillsDefaultIcon,
  authorDefault: AgentModeAuthorDefaultIcon,
  officialAvatar: OfficialSkillAvatar,
  knot: KnotIcon,
  back: SkillDetailBackIcon,
  headerBg: SkillDetailHeaderBg,
} as const;

/** Skill 详情页 Tab 图标（默认态 / 高亮态） */
export const SKILL_DETAIL_TAB_CONFIG = [
  {
    id: ESkillDetailTab.USAGE,
    labelKey: 'dba_skill_detail_tab_usage',
    defaultIcon: UsageTabDefaultIcon,
    activeIcon: UsageTabActiveIcon,
  },
  {
    id: ESkillDetailTab.LINKAGE,
    labelKey: 'dba_skill_detail_tab_linkage',
    defaultIcon: LinkageTabDefaultIcon,
    activeIcon: LinkageTabActiveIcon,
  },
  {
    id: ESkillDetailTab.VERSION,
    labelKey: 'dba_skill_detail_tab_version',
    defaultIcon: VersionTabDefaultIcon,
    activeIcon: VersionTabActiveIcon,
  },
] as const;

/** Skill 详情页区块图标 */
export const SKILL_DETAIL_SECTION_ICONS = {
  overview: OverviewSectionIcon,
  token: TokenSectionIcon,
  skillMd: SkillMdFileIcon,
  linkageRobot: LinkageRobotIcon,
} as const;

/** WOA 域名后缀，用于 Knot 按钮展示判断 */
export const WOA_HOSTNAME_SUFFIX = '.woa.com';

/** 个人令牌中心地址 */
export const PERSONAL_TOKEN_CENTER_URL =
  'https://databrain.woa.com/v2/user-center/personal-tokens-center';
